export default __webpack_public_path__ + "static/media/expandBoxPrimary.c7e23d3f.svg";